module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAAClAgMAAABHIlx1AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEXOKTn///9HcFDpgHEQAAAAAWJLR0QB/wIt3gAAAAd0SU1FB+gJAhUcK8H8XDMAAABJSURBVGje7cwxDQAwCAAwJPLgb/dUYoKDhFZAIwAAAAA4o8al0+l0Op1Op9PpdDqdTqdz6fnHPafT6XQ6nU6n0+l0Op1O586zAQzIwPKyJYDTAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTA5LTAyVDIxOjI4OjQzKzAwOjAwyz+9NgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0wOS0wMlQyMToyODo0MyswMDowMLpiBYoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/xyl.png
// module id = KrJv
// module chunks = 128